
export interface AnalyticsConfig {
  enabled: boolean;
  flushInterval: number;
  batchSize: number;
  maxRetries: number;
  retryDelay: number;
  maxRetryDelay: number;
  eventTimeout: number;
}

// Check if we should enable analytics
const shouldEnableAnalytics = () => {
  // Enable in production
  if (window.location.hostname !== 'localhost' && 
      window.location.hostname !== '127.0.0.1' &&
      !window.location.hostname.includes('lovable.app')) {
    return true;
  }
  
  // Enable in development if native PostHog is available (for testing)
  if (typeof window !== 'undefined' && window.posthog) {
    return true;
  }
  
  return false;
};

export const defaultConfig: AnalyticsConfig = {
  enabled: shouldEnableAnalytics(),
  flushInterval: 1000,
  batchSize: 10,
  maxRetries: 3,
  retryDelay: 1000,
  maxRetryDelay: 30000,
  eventTimeout: 30000,
};
